import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=33c51378&scoped=true&"
import script from "./Data.vue?vue&type=script&lang=js&"
export * from "./Data.vue?vue&type=script&lang=js&"
import style0 from "./Data.vue?vue&type=style&index=0&id=33c51378&prod&lang=css&"
import style1 from "./Data.vue?vue&type=style&index=1&id=33c51378&prod&lang=scss&"
import style2 from "./Data.vue?vue&type=style&index=2&id=33c51378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c51378",
  null
  
)

export default component.exports